import { useAppSelector } from "app/hooks";
import Breadcrumb from "components/Breadcrumb";
import {
  ReportType,
  selectBreadCrumbLabels,
  selectReportType,
} from "features/Reports";
import useQuery from "hooks/useQuery";
import { useNavigate, useLocation } from "react-router-dom";

export default function ReportsBreadcrumb() {
  let { pathname: url } = useLocation();
  const query = useQuery();
  const navigate = useNavigate();
  const reportType = useAppSelector(selectReportType);

  const breadCrumbLabels = useAppSelector(selectBreadCrumbLabels);

  const clickHandler = (index: number) => {
    if (index === 0) navigate(url);
    if (index === 1 && reportType === ReportType.Class_Report) {
      query.delete("classCode");
      navigate({
        search: query.toString(),
      });
    }
  };

  return <Breadcrumb labels={breadCrumbLabels} clickHandler={clickHandler} />;
}
